import React, { useState } from 'react';
// Global library
import { ContentDiv } from '../../../components/Containers';
import { ContentTitle } from '../../../components/layouts/ContentTitle';
import { PortfolioLightbox } from '../../../components/interfaces/PortfolioLightbox';
import { ProjectDescription } from '../../../components/layouts/ProjectDescription';
import { ProjectPreviews } from '../../../components/layouts/ProjectPreviews';
// Module library
import { INVENTORY_MANAGEMENT_DATA } from '../data/inventoryManagement';

const InventoryManagement = () => {
  const [isOpen, setOpen] = useState(false);
  const [currentImageIndex, setCurrentIndex] = useState(0);

  const { desc, previews, title } = INVENTORY_MANAGEMENT_DATA;

  return (
    <ContentDiv>
      <ContentTitle title={title} />
      <ProjectDescription projectDescriptionArray={desc} />
      <ProjectPreviews
        projectPreviewsArray={previews}
        setCurrentIndex={setCurrentIndex}
        onOpen={() => setOpen(true)}
      />
      <PortfolioLightbox
        currentImageIndex={currentImageIndex}
        setCurrentIndex={setCurrentIndex}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        images={previews}
      />
    </ContentDiv>
  );
};

export default InventoryManagement;
